import gql from "graphql-tag";

export const LINK_QUIZ_MUTATION = gql`
  mutation ($lessonId: Int!, $quizId: Int!) {
    linkQuiz(data: { lessonId: $lessonId, quizId: $quizId }) {
      quizId
    }
  }
`;
